import React, { Component } from 'react';
import { CloseOutlined, CloudUploadOutlined, DeleteOutlined, ExclamationCircleOutlined, FileFilled, RedoOutlined, UploadOutlined } from '@ant-design/icons';
import { Upload, Modal, Tooltip, Button, Spin, Divider, Checkbox } from 'antd';
import moment from 'moment';
// import Uploadlayer from '../../../components/FormComponent/Input/upload';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import Storage from '../../../services/local-store';
import formDataPostService from '../../../services/httpformData';
import userTrackService from '../../../services/usertrack-service';
import { PDFDocument } from 'pdf-lib';
import PatientInsuranceAcknowledgement from './patientInsuranceAcknowledgement';
import { indexOf } from 'ramda';
import {UPLOAD_URL} from '../../../constants/app-constants';

const $ = require('jquery');
const {homepage} = networkList;
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]

class Counselling_upload_new extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            'showDocument': false,
            patientDocument: [],
            body: [],
            tbody: [],
            thead: [{
                "key": 'document_description',
                'label': 'Corporate'
            },{
                "key": 's_no',
                'label': ''
            },{
                "key": 'document_description',
                'label': 'Retail/Individual'
            },  {
                "key": 's_no',
                'label': ''
            }, ],
            fileList:[],
            disable_15days: false,
            latest_counselling_id: null,
            current_counselling_id: null,
            uploadedFiles: Array(5).fill(null),
            description:Array.from({ length: 5 }, () => []),
            autoFilledFileList : [],
            preview_PatientCheckin_model:false,
            saveClicked:false,
            showModal: false,
            insuranceforpatientHistory:null,
        }
    }

    componentDidMount() {
        const { id, slug } = this.props.match.params;
        if(slug !== 'patients-history-details' && slug !== 'pending-docs' && slug!== ('pre-auth-worklist' || 'post-auth-worklist')){
        this.initial();
    } 
        // setTimeout(() => { this.initial() }, 1000)
    }

    componentWillUnmount() {
        this.setState({
            visible: false,

        });
    }

    initial() {
        this.getMasterDocumentTypes();
        const { id, slug } = this.props.match.params
        if (slug === 'patients-history-details') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        } if (slug === 'pending-docs') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        }
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            let tokenData = JSON.parse(Storage.get('current_token'));
            if (tokenData && tokenData['umr']) {
                this.setState({ showDocument: true, ui_form_type: 'add' });
                this.getPatientDocumentDetails();
            } else {
                this.setState({ showDocument: false, ui_form_type: 'add' })
            }
        }
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            let view = JSON.parse(Storage.get('counselling_view'));
            if (view && view[0]['umr']) {
                this.setState({ showDocument: true, ui_form_type: 'view' });
                this.getPatientDocumentDetails();
            } else {
                this.setState({ showDocument: false, ui_form_type: 'view' })
            }
        }
        if (slug === 'pre-auth-worklist' || slug === 'post-auth-worklist' || slug === 'query-worklist' || slug === 'gre-worklist' || slug === 'dmo-worklist' || slug === 'dmo-pending-worklist') {
            let yes = this.props
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        }
    }

    getMasterDocumentTypes() {
        this.setState({ loadding: true })
        let { getMasterDocumentTypes } = networkList;
        const { id, slug } = this.props.match.params
        let typeOfInsurance;
        let insuranceType;
        let containsInsuranceType;
        const user_data = JSON.parse(localStorage.getItem('user_data'))
        if(this.props.mydata && typeof this.props.mydata === 'object' && 'umr_no' in this.props.mydata) {
            const umrNoToMatch = this.props.mydata.umr_no;
            if(slug === 'pre-auth-worklist' || slug === 'post-auth-worklist' || slug === 'query-worklist' || slug === 'pending-docs' || slug === 'gre-worklist' || slug === 'dmo-worklist'){
                const matchingTbodyItem = this.props.tbody.find(item => item.umr_no === umrNoToMatch);
                if (matchingTbodyItem) {
                    typeOfInsurance = matchingTbodyItem.type_of_insurance;
                }
            } 
        }
        if(slug === 'patients-history-details'){
            let matchCounselling_id = this.props.mydata.counselling_id;
            const {counsellings} = this.props.resData[0];
            const hasInsuranceType = counsellings.find(item => item.counselling_id === matchCounselling_id);
            if(hasInsuranceType){
                containsInsuranceType = hasInsuranceType.type_of_insurance;
            }
        }
        if(slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            let {counselling_details} = this.props;
            insuranceType = counselling_details.type_of_insurance_name === 'Retail' ? 1 : 2
        }   
        try {
            postService(getMasterDocumentTypes, 'GET', {}).then(res => {
                if (res['status']) {
                    if(localStorage.getItem('insuranceType') === '1' || typeOfInsurance === 1 || insuranceType === 1 || containsInsuranceType === 1){
                        const excludedids = [5,24,43,62,81,100,125,144,163,181];
                        let data = res['data'];
                        let excludedData = data.filter(item => !excludedids.includes(item.id));
                        this.setState({ 'tbody': excludedData, loadding: false,'insuranceforpatientHistory':containsInsuranceType });
                        Storage.store('getMasterDocumentTypes', excludedData);
                    // }
                    // else if(slug === 'dmo-pending-worklist' && (user_data['roleid'] === 'RL_8GzM')){
                    //     const excludedids = [18, 37, 56]
                    //     let data = res['data'];
                    //     let excludedData = data.filter(item => excludedids.includes(item.id));
                    //     this.setState({ 'tbody': excludedData, loadding: false,'insuranceforpatientHistory':containsInsuranceType });
                    //     Storage.store('getMasterDocumentTypes', excludedData);
                    } else {
                        this.setState((state) => ({ 'tbody': res['data'] }));
                        this.setState({ loadding: false })                
                        Storage.store('getMasterDocumentTypes', res['data']);
                    }
                    
                } else {
                    this.setState((state) => ({ 'docTypes': [] }));
                    this.setState({ loadding: false })
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }
    }

    getPatientDocumentDetails() {
        this.setState({ loadding: true })
        let { getPatientDocumentDetails,getUploadPatientsDocumentsDetails } = networkList;
        const { id, slug } = this.props.match.params
        let tokenData = JSON.parse(Storage.get('current_token'));
        let user_data = JSON.parse(Storage.get('user_data'));
        let view = JSON.parse(Storage.get('counselling_view'));
        let payload = {}
        if (slug === 'patients-history-details') {
            let yes = this.props ? this.props : false
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props;
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': counselling_id })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        if (slug === 'pending-docs') {
            let yes = this.props.mydata ? this.props.mydata : false
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata;
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': parseInt(counselling_id) })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        if (slug === 'pre-auth-worklist' || slug === 'post-auth-worklist' || slug === 'query-worklist' || slug === 'gre-worklist' || slug === 'dmo-worklist' || slug === 'dmo-pending-worklist') {
            let yes = this.props.mydata ? this.props.mydata : false
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata;
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': counselling_id })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        // add counselling
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            // const counsellingId = JSON.parse(localStorage.getItem('counselling_view'));
            // const [coundellingid] = counsellingId.map(counselling_ID => (counselling_ID.counselling_id));
            payload = { "umr_no": tokenData['umr'], "ip_no": tokenData['ip'] || null, "unit_id": user_data['unitid'], "form_type": "add", "counselling_id": '' || null }
            this.setState({ "umr_no": tokenData['umr'], "ip_no": tokenData['ip'], "patient_name": tokenData['patient_name'], ui_form_type: 'add' })
        }
        // view counselling
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            const params = new URLSearchParams(this.props.location.search);
            let ui_counselling_id = params.get('cid');
            let current_counselling_id = this.props.counselling_details || '';
            let disable_15days = null
            if (view && view[0]['counselling_date']) {
                var days = Math.abs((moment(view[0]['counselling_date']).diff(moment(new Date()), 'day')));
                disable_15days = days > 15 ? true : false
            } else {
                disable_15days = false
            }
            payload = { "umr_no": view[0]['umr'], "ip_no": view[0]['ip_no'], "unit_id": user_data['unitid'], "form_type": "view", "counselling_id": current_counselling_id.counselling_id }
            this.setState({ "umr_no": view[0]['umr'], "ip_no": view[0]['ip_no'], "patient_name": view[0]['patient_name'], 'disable_15days': disable_15days, ui_form_type: 'view','current_counselling_id': current_counselling_id.counselling_id })
        }
        try {
            const Userlogobj ={
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "get Patient Document Details - Request",
                    "date": new Date(),
                    "meta": payload
                }
            }
            userTrackService(Userlogobj);
            postService('getPatientsDocumentsUploadbyMETA', 'POST', { "data": payload }).then(res => {
                const Userlogobjres ={
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "get Patient Document Details - Response",
                        "date": new Date(),
                        "meta": res
                    }
                }
                userTrackService(Userlogobjres);
                if (res['status']) {
                    let latest_cou_id = res['latest_counselling_id'] ? res['latest_counselling_id'] : null;

                    this.setState((state) => ({ 'patientDocument': res['data'],'latest_counselling_id': latest_cou_id }));
                    this.setState({ loadding: false })   
                    Storage.store('getPatientDocumentDetails', res['data'])
                    const selectedDocumentIds = [];
                    this.state.body.forEach(document => {
                        selectedDocumentIds.push(document.id.toString());
                    });
                    localStorage.setItem('document_ids',JSON.stringify(selectedDocumentIds));
                    this.setState({'body':[],uploadedFiles:Array(5).fill(null),fileList:[],})
                } else {
                    this.setState((state) => ({ 'patientDocument': [] }));
                    this.setState({ loadding: false })
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }
    }

    setModal1Visible(modal1Visible) {
        this.setState({ modal1Visible,insuranceforpatientHistory:'',uploadedFiles: Array(5).fill(null),fileList:[],uploadedFiles:[],loadding:true });
        this.initial()
    }
    handleChange = (info, index) => {
        let newFileList = [...this.state.fileList];
        newFileList[index] = info.fileList;
        this.setState({fileList:newFileList});
        let updatedFiles = info.fileList.map(file => file);
            let uploadedFiles = [...this.state.uploadedFiles];
            uploadedFiles[index] = updatedFiles;
            this.setState({uploadedFiles:uploadedFiles});
        
    };
    handleChange23 = (e, index) => {
        const { checked } = e.target;
        const { tbody,body } = this.state;
        const selectedDocument = tbody[index];
        let updatedBody = [...this.state.body];
        if (!Array.isArray(updatedBody)) {
            updatedBody = [];
        }
        if (checked) {
            updatedBody.push(selectedDocument);
        } else {
            updatedBody = updatedBody.filter(item => item.id !== selectedDocument.id);
        }
        this.setState({ body: updatedBody });
    };

    mergePDFs = async (pdfFiles) => {
        const mergedPdf = await PDFDocument.create();
        for (const pdfFile of pdfFiles) {
            if(pdfFile.type === 'application/pdf'){
            const pdfBytes = await pdfFile.arrayBuffer();
            const pdfDoc = await PDFDocument.load(pdfBytes);
            const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
            copiedPages.forEach((page) => {
                mergedPdf.addPage(page);
            });
        } else if (pdfFile.type.startsWith("image/")) {
            const imgData = await pdfFile.arrayBuffer();
            // let img = await mergedPdf.embedPng(imgData);
            let img;
            if (pdfFile.type === 'image/png') {
                img = await mergedPdf.embedPng(imgData);
            } else if (pdfFile.type === 'image/jpeg' || pdfFile.type === 'image/jpg') {
                img = await mergedPdf.embedJpg(imgData);
            }
            const page = mergedPdf.addPage([img.width, img.height]);
            const { width, height } = page.getSize();
            page.drawImage(img, {
                x: 0,
                y: 0,
                width: width,
                height: height,
                opacity: 0.5,
            });
        } else {
            console.warn(`Unsupported file type: ${pdfFile.type}`);
        }
    }
    return mergedPdf.save();
    }
    deletePatientInsuranceDocuments = async(index) => {
        let {patientDocument,autoFilledFileList,body} = this.state;
        let payload = {
            "umr_no":patientDocument[0].umr_no,
            "document_url":autoFilledFileList[index][0].url,
            "unit_id":patientDocument[0].unit_id,
            "ip_no":patientDocument[0].ip_no || null
        }
        postService('deletePatientInsuranceDocuments', 'POST', { "data": payload }).then(res => {
            if(res.status){
                Modal.success({
                    title: `success`,
                    content: `Record Deleted`,
                    zIndex: '1022'
                });
                this.getPatientDocumentDetails();
                this.setState({ loadding: false});
                this.state.body = [];
            }
        })
    }
    downloadPatientDocumentsAsPDF() {
        this.setState({ loadding: true })
        let { downloadPatientDocumentsAsPDF } = networkList;
        const { id, slug } = this.props.match.params
        let tokenData = JSON.parse(Storage.get('current_token'));
        let user_data = JSON.parse(Storage.get('user_data'));
        let view = JSON.parse(Storage.get('counselling_view'));
        let payload = {}
        if (slug === 'patients-history-details') {
            let yes = this.props.mydata ? this.props.mydata : false
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "add" || "view", "counselling_id": counselling_id }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': counselling_id })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        if (slug === 'pending-docs') {
            let yes = this.props.mydata ? this.props.mydata : false
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': parseInt(counselling_id) })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        if (slug === 'pre-auth-worklist' || slug === 'post-auth-worklist' || slug === 'query-worklist' || slug === 'gre-worklist' || slug === 'dmo-worklist' || slug === 'dmo-pending-worklist') {
            let yes = this.props.mydata ? this.props.mydata : false
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": user_data['unitid'], "form_type": "add", "counselling_id": '' || null }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': counselling_id })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        // add counselling
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            payload = { "umr_no": tokenData['umr'], "ip_no": tokenData['ip'] || null, "unit_id": user_data['unitid'], "form_type": "add", "counselling_id": '' || null }
            this.setState({ "umr_no": tokenData['umr'], "ip_no": tokenData['ip'], "patient_name": tokenData['patient_name'], ui_form_type: 'add' })
        }
        // view counselling
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            const params = new URLSearchParams(this.props.location.search);
            let ui_counselling_id = params.get('cid');
            let current_counselling_id = this.props.counselling_details || '';
            let disable_15days = null
            payload = { "umr_no": view[0]['umr'], "ip_no": view[0]['ip_no'], "unit_id": user_data['unitid'], "form_type": "add" || "view", "counselling_id": current_counselling_id.counselling_id || '' }
            this.setState({ "umr_no": view[0]['umr'], "ip_no": view[0]['ip_no'], "patient_name": view[0]['patient_name'], 'disable_15days': disable_15days, ui_form_type: 'view','current_counselling_id': current_counselling_id.counselling_id })
        }
        try {
            postService('downloadPatientDocumentsAsPDFNewApi', 'POST', { "data": payload }).then(res => {
                if (res['status']) {
                    const { base_url } = networkList;
                    const downloadUrl = `${UPLOAD_URL}${res.single_file_url.replace(/^uploads\//, '')}`;
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', '');
                    link.setAttribute('target', '_blank');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.setState({ loadding: false });
                } else {
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : 'Oops, Something is wrong. Please try again.',
                        zIndex: 1022
                    })
                    this.setState({ loadding: false });
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })
        }
    }
    handleDescriptionChange = (index, e) => {
        const { description } = this.state;
        const newDescription = [...description]; // Create a copy of the description array
        const value = e.target.value// Trim the input value to remove leading and trailing whitespace
        newDescription[index] = value;
        this.setState({ description: newDescription });
    };
    
    render() {
        let { tbody, showDocument, patientDocument, thead, umr_no, ip_no, patient_name, fileList, loadding, hideonHistory, ui_form_type, disable_15days, current_counselling_id, latest_counselling_id,preview_PatientCheckin_model,insuranceforpatientHistory } = this.state;
        const pat_doc_ids = patientDocument && patientDocument.length > 0 ? patientDocument.map(doc => parseInt(doc.document_id)) : [];
        tbody.forEach(item => {
            if (pat_doc_ids.includes(item.id)) {
                item.checked = true; // Autofill checkbox
                if (!this.state.body.find(doc => doc.id === item.id)) {
                    this.state.body.push({ id: item.id, document_description: item.document_description, document_short_code:item.document_short_code, document_type:item.document_type,upload_type:item.upload_type,is_mandatory:item.is_mandatory }); // Add to state.body if not already present
                }
                item.disabled = true
            } else {
                item.disabled = false
            }
        });
        // pat_doc_ids = pat_doc_ids.filter(id => id !== deletedItemId);
        const documentUrls = patientDocument && patientDocument.length > 0 ? patientDocument.map(item => item.document_url) : [];
        let autoFilledFileList = [];
        documentUrls.forEach(url => {
            autoFilledFileList.push([{ uid: '-' + autoFilledFileList.length, name: url, status: 'done', url: url }]);
        });
        this.state.autoFilledFileList=autoFilledFileList
        const { id, slug } = this.props.match.params
        let typeOfInsurance;
        let insuranceType;
        let containsInsuranceType;
        const slugsData = ['pre-auth-worklist','post-auth-worklist','view-finanical-counselling','view-other-counselling'];
        if(this.props.mydata && typeof this.props.mydata === 'object' && 'umr_no' in this.props.mydata) {
            const umrNoToMatch = this.props.mydata.umr_no;
            if(slug === 'pre-auth-worklist' || slug === 'post-auth-worklist' || slug === 'query-worklist' || slug === 'pending-docs' || slug === 'gre-worklist' || slug === 'dmo-worklist'){
                const matchingTbodyItem = this.props.tbody.find(item => item.umr_no === umrNoToMatch);
                if (matchingTbodyItem) {
                    typeOfInsurance = matchingTbodyItem.type_of_insurance;
                }
            }
        }
        if(slug === 'patients-history-details'){
            containsInsuranceType = insuranceforpatientHistory
        }
        if(slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            let {counselling_details} = this.props;
            insuranceType = counselling_details.type_of_insurance_name === 'Retail' ? 1 : 2
        }
        const isDisabled = ui_form_type === 'view' && disable_15days === true;
        return (<React.Fragment>
                    {slug === 'patients-history-details' || slug === 'pending-docs' || slug=== 'pre-auth-worklist' || slug === 'post-auth-worklist' || slug === 'query-worklist' || slug === 'pending-docs' || slug === 'gre-worklist' || slug === 'dmo-worklist' || slug === 'dmo-pending-worklist' || slug === 'view-finanical-counselling' || slug === 'view-other-counselling'? null : <React.Fragment> {showDocument ?
                        <div className={`col-10 mb-2 icon mx-auto p-2 text-center doc-ena`} style={{ backgroundColor: '#666' }} onClick={() => { this.setModal1Visible(true); }}>
                            <FileFilled style={{ fontSize: 18, color: '#ffff' }} />
                            {/* <p className="mt-2 mb-0">Upload Documents</p> */}
                        </div>
                        :
                        <div className={`col-10 mb-2 icon mx-auto p-2 text-center doc-dis`} style={{ backgroundColor: '#666' }}>
                            <FileFilled style={{ fontSize: 18, color: '#ffff' }} />
                            {/* <p className="mt-2 mb-0">Upload Documents</p> */}
                        </div>
                    }</React.Fragment>}
                    {
                        ((localStorage.getItem("insuranceType") === '' || localStorage.getItem("insuranceType") === undefined || localStorage.getItem("insuranceType") === null) && (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling')) ?
                        <Modal
                        centered
                        visible={this.state.modal1Visible}
                        width='35%'
                        height='45%'
                        zIndex={1021}
                        footer={null}
                        // title="Warning"
                        
                    >
                        <div style={{display:'flex',}}><ExclamationCircleOutlined style={{ color: 'orange', fontSize: '24px', marginRight: '10px' }} /><p style={{color:'black'}}>Warning</p></div>
                        <p>Please Select Type Of Insurance* Before Uploading Documents</p>
                        <div style={{display:'flex',justifyContent:'flex-end'}}>
                        <button className="btn" style={{backgroundColor: '#067fb8', color: 'white'}} onClick={() => this.setModal1Visible(false)}> Ok</button>
                        </div>
                    </Modal>
                        :
                    <Modal
                        centered
                        visible={this.state.modal1Visible}
                        width='95%'
                        height='95%'
                        zIndex={1021}
                        footer={null}
                    >
                        <CloseOutlined type="close" className=" popup-close" onClick={() => this.setModal1Visible(false)} />
                        {ui_form_type === 'view' && disable_15days == true ?
                            <React.Fragment>
                                <h4 className="text-center">Upload Documents</h4>
                                <p className="text-center mb-5 text-danger">This counselling has expired, Uploading documents is not allowed</p>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <h4 className="text-center">Upload Documents</h4>
                                <p className="text-center mb-5">Select the documents required for Cash or Insurance patients</p>
                            </React.Fragment>}                            
                        {(loadding) && <div className="loadding h-100 w-100" style={{ left: 0, zIndex: 9999 }}> <Spin ></Spin></div>}

                        <div className="row pb-3">
                            <div className="col-6 my-auto">
                                <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_name ? patient_name : '--'}</Tooltip>
                                </h6>
                            </div>
                            <div className="col-2 my-auto">
                                <h6 className="mb-0"> <Tooltip title="UMR Number">{umr_no ? umr_no : '--'}</Tooltip></h6>
                            </div>
                            <div className="col-2 my-auto">
                                <h6 className="mb-0"> <Tooltip title="IP Number">{ip_no ? ip_no : '--'}</Tooltip></h6>
                            </div>

                            <div className="col-2 my-auto">
                                <button className="btn btn-success text-capitalize float-right" onClick={() => { this.downloadPatientDocumentsAsPDF() }} disabled={isDisabled}>
                                    <img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download</span>
                                </button>
                            </div>
                            
                        </div>
                        <div className="financial-table table-responsive pop-table">
                            <table style={{ borderCollapse: 'collapse', textAlign: 'center', marginTop:'10px'}} className="table table-hover table-bordered mb-0 bg-white">
                                <thead style={{ backgroundColor: '#084b69' }}>
                                <tr>
                                    <th colSpan="3" style={{ border: '1px solid black', padding: '8px' }}>Insurance Documents</th>
                                </tr>
                                </thead>
                                <tbody>
                                {tbody.map((item, key) => {
                                    const matchedDoc = patientDocument.find(doc => parseInt(doc.document_id) === item.id);
                                    return (
                                    <>
                                    <tr key={key} className={`${!pat_doc_ids.includes(item.id) ? 'tb-blocked' : ''} ${ui_form_type === 'view' && disable_15days ? 'tb-blocked' : ''}`}>
                                        <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{item.disabled ? '*' : null}{key + 1}</th>
                                        
                                        {item.is_mandatory === 1 ? <th style={{ border: '1px solid black', padding: '8px' }}>{item.document_description}{item.document_description ? '*' : null}{matchedDoc && (
                                                    <a style={{ marginLeft: '10px' }} href={`${UPLOAD_URL}${umr_no}/${matchedDoc.document_url}`} target="_blank" className="pr-2">
                                                        {matchedDoc.document_url}
                                                    </a>
                                                )}</th> : (<th style={{ border: '1px solid black', padding: '8px' }}>{item.document_description}{matchedDoc && (
                                                    <a style={{ marginLeft: '10px' }} href={`${UPLOAD_URL}${umr_no}/${matchedDoc.document_url}`} target="_blank" className="pr-2">
                                                        {matchedDoc.document_url}
                                                    </a>
                                                )}</th>)}
                                        <th style={{ border: '1px solid black', padding: '8px' }}>
                                            <input
                                                style={{ padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                type="checkbox"
                                                checked={this.state.body && this.state.body.some(doc => doc.id === item.id)}
                                                disabled={true}
                                                onChange={(e) => this.handleChange23(e, key)}
                                            />
                                        </th>
                                    </tr>
                                    </>)})}
                                </tbody>
                            </table>
                            {preview_PatientCheckin_model && (
                                <PatientInsuranceAcknowledgement {...this.props} {...this.state}
                                    onCancel={() => this.setState({ preview_PatientCheckin_model: false })}
                                />
                            )}
                            <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                            <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setModal1Visible(false)} disabled={isDisabled}> Close</button>
                            </div>
                        </div>
                    </Modal>
    }
        </React.Fragment>)
    }
}
export default Counselling_upload_new;